<template>
  <div class="help-page page-padding-top">
    <top-bar :title="i18n.t('help.title')"  @back="back"></top-bar>

    <div class="tabs">
      <Tabs
        v-model="tabIndex"
        :line-width="26"
        :line-height="4"
        color="#23262F"
        title-inactive-color="#85898F"
        title-active-color="#23262F"
        @change="changeTab"
      >
        <Tab v-for="(item, i) in tabList" :key="i" :title="item"></Tab>
      </Tabs>
    </div>

    <div class="question-list">
      <div class="list " v-for="(item, i) in questionList" :key="i" :class="i == showIndex ? 'show' : ''" @click="changeShow(i)">
        <div class="title flex-center-between">
          <span>{{item.title}}</span>
          <Icon class="arrow" name="arrow" size="20" color="#353945"></Icon>
        </div>
        <div class="content" >{{item.content}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import topBar from '@/components/topBar'
import { Button, Tabs, Tab, Icon } from 'vant'
import { helpList } from '@/api/setting'
export default {
  components: {
    Button,
    Icon,
    Tabs,
    Tab,
    topBar,
  },
  data() {
    return {
      tabIndex: '',
      showIndex: -1,
      keyword: '',
      timeUrl:require('../../assets/imgs/icon-time.png'),
      tabList: ['常见问题', '充提币问题', '认证问题', '安全问题', '交易问题', '资产问题'],
      questionList: [
        {
          title: '新手必备',
          content: '新手内容新手内容新手内容新手内容新手内容新手内容新手内容'
        },
        {
          title: '跟单交易',
          content: '跟单交易跟单交易跟单交易跟单交易'
        },
        {
          title: '账户功能',
          content: '账户功能账户功能账户功能账户功能账户功能账户功能账户功能账户功能账户功能账户功能账户功能账户功能'
        },
      ]
    }
  },
  mounted() {
  },
  methods: {
    init() {
      helpList().then(res => {
        this.helpDataList = res.data.Items
        this.helpDataListBak = res.data.Items
      })
    },
    back() {
      this.$router.go(-1)
    },
    changeTab(val) {
      console.log(111, val)
    },
    changeShow(i) {
      if (this.showIndex == i) {
        this.showIndex = -1
      } else {
        this.showIndex = i
      }
    }
  }
}
</script>